<template>
  <Flex direction="column">
    <BaseHeading size="s">
      {{ filters.capitalize($t('global.items.service', 2)) }}
    </BaseHeading>
    <EmptyResults v-if="serviceCategories.length < 1" />
    <div v-else>
      <Category
        v-for="(category, index) in serviceCategories"
        :key="index"
        :category="category"
        :servicePackages="servicePackagesByCategoryId.get(category.id) ?? []"
        :index="index"
      >
        {{ category.name }}
      </Category>
    </div>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import filters from '@/filters';
import { useServicesStore } from '@/stores/services';
import type { ServicePackage } from '@/types';
import EmptyResults from '../../EmptyResults.vue';
import Category from './Category.vue';

defineOptions({
  name: 'ServicesList',
});

const { serviceCategories, servicePackages } = storeToRefs(useServicesStore());

const servicePackagesByCategoryId = computed(() => {
  const map = new Map<number, ServicePackage[]>();

  servicePackages.value.forEach((servicePackage) => {
    const categoryId = servicePackage.category?.id;
    if (categoryId === undefined) {
      return;
    }

    map.set(categoryId, [...(map.get(categoryId) ?? []), servicePackage]);
  });
  return map;
});
</script>
